// Direction is a property of the *language*, not a hard-coded `=== 'ar'` check.
//
// With ~20 languages there are several RTL scripts (Arabic, Urdu, Persian,
// Hebrew…), so every consumer must derive direction from this helper instead of
// comparing the active language to "ar".

import { LANGUAGE_BY_CODE, type TextDirection } from "./languages";

/** Resolve a language code to its writing direction (defaults to LTR). */
export function getDirection(code: string): TextDirection {
  return LANGUAGE_BY_CODE[code]?.dir ?? "ltr";
}

export function isRtl(code: string): boolean {
  return getDirection(code) === "rtl";
}
